enum TourUserChoice {
	ShowLater = 0,
	NeverShow = 1,
	Completed = 2
}

export default TourUserChoice;
